/**
 * Description: Alco Sistema Theme Scripts File
 * Author: Global IID
 * Version: 1.0.0
 * License: GNU General Public License v2 or later
 * License URI: http://www.gnu.org/licenses/gpl-2.0.html
 */

function gfFieldHasValue(field) {
  if (!field) {
    return false;
  }

  if (field.matches('select')) {
    return gfSelectHasValue(field);
  }

  if (field.matches('input[type="checkbox"], input[type="radio"]')) {
    return field.checked;
  }

  if (typeof field.value !== 'string') {
    return false;
  }

  var rawValue = field.value.trim();
  if (!rawValue) {
    return false;
  }

  if (field.matches('input[type="tel"]')) {
    // Ignore mask placeholders such as "(___) ___-____".
    return /[0-9]/.test(rawValue);
  }

  return /[^\s_]/.test(rawValue);
}

function gfSelectHasValue(field) {
  var selectedOptions = field.selectedOptions || [];
  for (var i = 0; i < selectedOptions.length; i++) {
    var option = selectedOptions[i];
    if (option.value && option.value.trim() !== '') {
      return true;
    }
  }

  return false;
}

function gfUpdateFloatingLabelState(field) {
  var gfield = field && field.closest ? field.closest('.gfield') : null;
  if (!gfield) {
    return;
  }

  var valueFields = gfield.querySelectorAll(
    'input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]), textarea, select'
  );
  var hasValue = gfFieldListHasValue(valueFields);
  gfield.classList.toggle('ss-field-has-value', hasValue);
}

function gfFieldListHasValue(fields) {
  for (var i = 0; i < fields.length; i++) {
    if (gfFieldHasValue(fields[i])) {
      return true;
    }
  }

  return false;
}

function gfUpdateSubfieldLabelState(field) {
  if (!field || !field.closest) {
    return;
  }

  var subfieldWrap = field.closest('.ginput_complex span, .ginput_complex > div');
  if (!subfieldWrap) {
    return;
  }

  var hasSubLabel = subfieldWrap.querySelector('.gform-field-label--type-sub');
  if (!hasSubLabel) {
    return;
  }

  subfieldWrap.classList.toggle('ss-subfield-has-value', gfFieldHasValue(field));
}

function gfSyncAllFloatingLabelStates(root) {
  root = root || document;
  var groups = root.querySelectorAll('.gform-theme--framework .gfield, .gform_wrapper .gfield');
  gfForEach(groups, function(gfield) {
    gfUpdateFloatingLabelState(gfield);
  });
  gfForEach(root.querySelectorAll('.gform-theme--framework .gfield .ginput_complex input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]), .gform-theme--framework .gfield .ginput_complex textarea, .gform-theme--framework .gfield .ginput_complex select, .gform_wrapper .gfield .ginput_complex input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]), .gform_wrapper .gfield .ginput_complex textarea, .gform_wrapper .gfield .ginput_complex select'), function(field) {
    gfUpdateSubfieldLabelState(field);
  });
}

function gfForEach(nodeList, callback) {
  for (var i = 0; i < nodeList.length; i++) {
    callback(nodeList[i], i);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  gfSyncAllFloatingLabelStates();
});

document.addEventListener('input', function(event) {
  if (event.target && event.target.matches('.gform-theme--framework .gfield input, .gform-theme--framework .gfield textarea, .gform_wrapper .gfield input, .gform_wrapper .gfield textarea')) {
    gfUpdateFloatingLabelState(event.target);
    gfUpdateSubfieldLabelState(event.target);
  }
}, true);

document.addEventListener('change', function(event) {
  if (event.target && event.target.matches('.gform-theme--framework .gfield input, .gform-theme--framework .gfield textarea, .gform-theme--framework .gfield select, .gform_wrapper .gfield input, .gform_wrapper .gfield textarea, .gform_wrapper .gfield select')) {
    gfUpdateFloatingLabelState(event.target);
    gfUpdateSubfieldLabelState(event.target);
  }
}, true);

document.addEventListener('keyup', function(event) {
  if (event.target && event.target.matches('.gform-theme--framework .gfield input, .gform-theme--framework .gfield input[type="tel"], .gform_wrapper .gfield input[type="tel"], .gform-theme--framework .gfield textarea, .gform_wrapper .gfield input, .gform_wrapper .gfield textarea')) {
    gfUpdateFloatingLabelState(event.target);
    gfUpdateSubfieldLabelState(event.target);
  }
}, true);

document.addEventListener('blur', function(event) {
  if (event.target && event.target.matches('.gform-theme--framework .gfield input, .gform-theme--framework .gfield input[type="tel"], .gform_wrapper .gfield input[type="tel"], .gform-theme--framework .gfield textarea, .gform-theme--framework .gfield select, .gform_wrapper .gfield input, .gform_wrapper .gfield textarea, .gform_wrapper .gfield select')) {
    gfUpdateFloatingLabelState(event.target);
    gfUpdateSubfieldLabelState(event.target);
  }
}, true);

document.addEventListener('focus', function(event) {
  if (event.target && event.target.matches('.gform-theme--framework .gfield input, .gform-theme--framework .gfield textarea, .gform-theme--framework .gfield select, .gform_wrapper .gfield input, .gform_wrapper .gfield textarea, .gform_wrapper .gfield select')) {
  }
}, true);

if (window.jQuery) {
  window.jQuery(document).on('gform_post_render gform_page_loaded', function() {
    gfSyncAllFloatingLabelStates();
  });
}
